export enum MeterTypeEnum {
  SMART = 'SMART',
  CLASSICAL = 'CLASSICAL',
}

export namespace MeterTypeEnum {
  export const getTranslation = (value?: MeterTypeEnum) => {
    switch (value) {
      case MeterTypeEnum.SMART:
        return 'common.yes';
      default:
        return 'common.no';
    }
  };
}
